Vue.asyncComponent('ak-badge', {
    data() {
        return {
            showConfirm: false,
        }
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        color: {
            type: Object
        },
        showRemove: {
            type: Boolean
        },
        enableConfirmOnRemove: {
            type: Boolean,
            required: false,
            default: false
        },
        confirmTitle: {
            type: String,
            required: false,
        },
        confirmText: {
            type: String,
            required: false,
        },
        confirmButtonText: {
            type: String,
            required: false,
        },
        cancelButtonText: {
            type: String,
            required: false,
        },
    },
    methods: {
        triggerRemove() {
            this.$emit('remove');
        },
        clickRemove(e) {
            if (this.enableConfirmOnRemove) {
                this.showConfirm = true;
                return;
            }

            this.triggerRemove();
        },
        onConfirm(e) {
            this.showConfirm = false;
            this.triggerRemove();
        },
        onCancel(e) {
            this.showConfirm = false;
        }
    }
}, 'layout/ak-badge.html');